import isFQDN from 'validator/lib/isFQDN'
import { i18n } from '@/i18n'

export default Validator => {
  Validator.register(
    'domain',
    function (value) {
      return isFQDN(value)
    },
    i18n.t('invalid', { x: ':attribute' }),
  )
}
